(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("scoreAssignment", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/evaluations/assignments/scoreAssignmentView.html",
            controller: ["scoreAssignmentsResource", "messageService", "Upload", "$timeout", "$state", "$translate", ScoreAssignmentCtrl],
            controllerAs: "vm"
        };
        function ScoreAssignmentCtrl(scoreAssignmentsResource, messageService, Upload, $timeout, $state, $translate) {
            var vm = this;
            vm.loading = true;
            var lang = $translate.proposedLanguage() || $translate.use();
            lang = lang.replace("-", "_");
            vm.tinymceOptions = {
                resize: false,
                height: 300,
                plugins: "autoresize code wordcount",
                language: lang
            };
            vm.$onInit = function () {
                if (!$state.params.attemptId) {
                    $state.go("main.evaluations.assignments");
                    return;
                }
                scoreAssignmentsResource.get({ attemptId: $state.params.attemptId }, function (data) {
                    vm.model = data;
                    if (data.status === 3)
                        vm.incomplete = 2;
                    else
                        vm.incomplete = 1;
                    vm.model.markIncomplete = vm.incomplete === 2;
                    vm.loading = false;
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.upload = function (file) {
                if (file) {
                    file.upload = Upload.upload({
                        url: "api/learningitems/temp/files",
                        data: {
                            file: file
                        }
                    });
                    file.upload.then(function (response) {
                        $timeout(function () {
                            if (response.data.length > 0) {
                                vm.model.markedAssignmentName = response.data[0].fileName;
                                vm.model.markedAssignmentUrl = response.data[0].fileUrl;
                                messageService.success("common.dropzone.uploadedFileMessage");
                                vm.progress = 0;
                            }
                        });
                    }, function (response) {
                        messageService.error(response);
                        vm.progress = 0;
                    }, function (evt) {
                        vm.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.removeFile = function () {
                vm.model.markedAssignmentName = null;
                vm.model.markedAssignmentUrl = null;
            };
            vm.changeStatus = function () {
                if (!vm.model.markIncomplete) {
                    if (vm.model.score) {
                        if (vm.model.score >= vm.model.passingScore)
                            vm.model.status = 5; //pass
                        else
                            vm.model.status = 4;
                    }
                }
                else
                    vm.model.status = 3; // the status will be a incomplete regardless of the passing score
            };
            vm.cancel = function () {
                $state.go("main.evaluations.assignments");
            };
            vm.save = function () {
                if (vm.form.$invalid || vm.saving) {
                    vm.showErrors = true;
                    return;
                }
                vm.saving = true;
                var bindingModel = {
                    attemptId: vm.model.attemptId,
                    score: vm.model.score,
                    markedAssignmentName: vm.model.markedAssignmentName,
                    markedAssignmentUrl: vm.model.markedAssignmentUrl,
                    comments: vm.model.comments,
                    markIncomplete: vm.model.markIncomplete
                };
                scoreAssignmentsResource.save({ attemptId: $state.params.attemptId }, bindingModel, function (data) {
                    vm.model = data;
                    messageService.success("common.changesSaved");
                    vm.saving = false;
                    $state.go("main.evaluations.assignments");
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            };
            vm.updateForm = function () {
                vm.model.markIncomplete = vm.incomplete === 2;
                vm.changeStatus();
            };
        }
    });
}());
